import { render, staticRenderFns } from "./PaymentSettings.vue?vue&type=template&id=19873ca0&scoped=true"
import script from "./PaymentSettings.vue?vue&type=script&lang=ts"
export * from "./PaymentSettings.vue?vue&type=script&lang=ts"
import style0 from "./PaymentSettings.vue?vue&type=style&index=0&id=19873ca0&prod&lang=scss&scoped=true"
import style1 from "./PaymentSettings.vue?vue&type=style&index=1&id=19873ca0&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19873ca0",
  null
  
)

export default component.exports